import * as React from "react";
import { cn } from "../lib/utils";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, id, "aria-describedby": describedBy, ...props }, ref) => {
    const invalid = Boolean(error);
    return (
      <>
        <textarea
          id={id}
          ref={ref}
          aria-invalid={invalid || undefined}
          aria-describedby={error && id ? `${id}-error` : describedBy}
          className={cn(
            "flex min-h-[80px] w-full rounded-lg border border-input bg-background px-3 py-2 text-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
            invalid && "border-destructive focus-visible:ring-destructive",
            className,
          )}
          {...props}
        />
        {error ? (
          <p
            id={id ? `${id}-error` : undefined}
            role="alert"
            className="mt-1 text-xs font-medium text-destructive"
          >
            {error}
          </p>
        ) : null}
      </>
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
